import { getAPIFromDomain } from "../lib/api";

export interface Inventory {
  product_id: string;
  facilities: string[];
  channels: string[];
  available_for_sale: number;
  available_for_work_orders: number;
  on_hand: number;
  in_transit: number;
  on_hold: number;
  damaged: number;
  backorder: number;
  incoming: number;
  reserved: number;
  to_be_reserved: number;
  reserved_orders: Order[];
  orders_to_be_reserved: Order[];

  //new inventory fields
  available_to_pick: number;
  processing: number;
  pending: number;
  to_be_processed: number;
}

export interface Order {
  id: string;
  order_id: string;
  item_quantity: number;
}

export interface FetchInventoryQuery {
  version: 1 | 2;
  product_id: string;
  organization_id: string;
  channels?: string[];
  facilities?: string[];
}

/* function overload definition */
export function fetchInventory(query: FetchInventoryQuery & { collate?: false }): Promise<Inventory>;
export function fetchInventory(query: FetchInventoryQuery & { collate: true }): Promise<Inventory[]>;
export async function fetchInventory(query: FetchInventoryQuery & { collate?: boolean }) {
  const { product_id: id, version, ...params } = query;
  const api = getAPIFromDomain("fulfillment", version);
  const res = await api.get(`/inventories/${id}`, {
    params: params,
  });

  if (params.collate) return res.data.data;
  return res.data;
}

export async function fetchInventories(query: {
  version: 1 | 2;
  ids: string[];
  organization_id: string;
  per_page: number;
}): Promise<Inventory[]> {
  const { version, ...params } = query;
  const api = getAPIFromDomain("fulfillment", version);
  const res = await api.get(`/inventories`, {
    params: params,
  });
  return res.data.data;
}

export const updateInventoryDetails = (userId: string, itemId: string, body: unknown) => {
  const api = getAPIFromDomain();
  const url = `/users/${userId}/inventory_items/${itemId}`;
  return api.put(url, body);
};

// Category items
export const lookupCategoryItems = (text: string) => {
  const api = getAPIFromDomain();
  const url = `/category_items?q=${text}`;
  return api.get(url);
};
